<div class="container-fluid">
  <ng-container *ngIf="!userService.isCallCenterUser()">
    <div class="row mt-4 m-lg-4 h-100">
      <div class="col-12 col-lg-4 mb-2" *ngIf="isAccountSelected">
        <div class="section-bc p-4 rounded rounded-lg h-100 ">
          <h5 class="card-title primary-color">{{'DRAFTS' | translate}}</h5>
          <app-drafts [boxView]="true"></app-drafts>
        </div>
      </div>
      <div class="col-12 col-lg-4 mb-2" *ngIf="!isAccountSelected">
        <div *ngFor="let account of accounts">
          <div class="section-bc p-4 rounded rounded-lg h-100 " >
            <h5 class="card-title primary-color">{{account.accountCode}}</h5>
            <button class="btn btn-xs btn-primary m-2"
                    (click)="accessAccount(account)">{{"BUTTON.ENTER" | translate}}
            </button>
            <button class="btn btn-xs btn-primary m-2" *appFeaturesAuth="{section:'BUTTON',identifier:'BUTTON.RESA_REDIRECT'}"
                    (click)="redirectToResa(account.accountCode)">{{"BUTTON.RESA_REDIRECT" | translate}}
            </button>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-4 mb-2">
        <div class="section-bc p-4 rounded rounded-lg h-100 ">
          <h5 class="card-title primary-color">{{'PAGE.DASHBOARD.HELP_TITLE' | translate}}</h5>
          <app-help></app-help>
        </div>
      </div>
      <!-- <div class="col-12 col-lg-4 mb-2">
         <div class="section-bc p-4 rounded rounded-lg h-100 ">
           <h5 class="card-title primary-color">{{'PAGE.DASHBOARD.ALERT_TITLE' | translate}}</h5>
         </div>
       </div> -->
    </div>
    <!--<app-contact-infocert></app-contact-infocert> -->
  </ng-container>

  <ng-container *ngIf="userService.isCallCenterUser()">
    <div class="row mt-4 m-2 m-sm-4 h-100">
      <div class="alert alert-info w-100 rounded" role="alert">
        <h4 class="alert-heading">{{'WELOCOME' | translate}} &nbsp;{{userService.getUser().identityId}}</h4>
        <p>{{'WELCOME_DESC' |translate}}</p>
      </div>
    </div>
  </ng-container>
</div>
